import "@credit-acceptance/uikit/css";
import "@credit-acceptance/uikit/scss/Header";

import { updateHeadStyle } from "@credit-acceptance/common-frontend";
import { Header } from "@credit-acceptance/uikit";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import styles from "./App.module.scss";

/**
 * Page Not Found Main Component
 */
function App() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t("pageNotFound.title");
  }, [t]);

  useEffect(() => {
    const style = `
      body {
        background-color: var(--background-color);
      }
    `;
    updateHeadStyle(style);
  }, []);

  return (
    <div className={styles.wrapper}>
      <Header kind="section" text={t("pageNotFound.heading")} />
    </div>
  );
}

export default App;
